import { render, staticRenderFns } from "./SubGroupAnalysis.html?vue&type=template&id=2ed6e678&scoped=true&"
import script from "./SubGroupAnalysis.vue?vue&type=script&lang=js&"
export * from "./SubGroupAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SubGroupAnalysis.scss?vue&type=style&index=0&id=2ed6e678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed6e678",
  null
  
)

export default component.exports